import axios from 'axios';

import {
	getStoredRoleData,
	getStoredTokenData
} from '../store/auth-context';

import { API_CONSTANTS } from './apiConstants';

const API_URL = API_CONSTANTS.API_URL;

export const getHospitalslist = async () => {
	const token = getStoredTokenData().token;
	return axios.get(`${API_URL}/api/super/get-hospitals`, {
		headers: {
			token: `${token}`
		}
	});
};

export const newUserCreation = async (userInfo) => {
	const token = getStoredTokenData().token;
    return axios.post(
        `${API_URL}/api/super/create-user`,
        userInfo,
        {
			headers: {
				token: `${token}`
			}
		}
    );
}

export const getTimeReviewing = async () => {
	const token = getStoredTokenData().token;
	return axios.get(`${API_URL}/api/super/get-time-studies`, {
		headers: {
			token: `${token}`
		}
	});
};